import { useState, useContext, useEffect } from "react";
import {
  FaCalculator,
  FaCogs,
  FaEdit,
  FaExclamationTriangle,
  FaFileUpload,
  FaGlobe,
  FaGraduationCap,
  FaPlusCircle,
  FaPrint,
  FaTrashAlt,
  FaUndo,
  FaUpload,
  FaBriefcase,
  FaUser,
  FaCalendarAlt,
  FaChartLine,
  FaUsers,
  FaCheck,
  FaDollarSign,
} from "react-icons/fa";
import ActionButton from "components/ui/controls/action-button/ActionButton";
import Button from "components/ui/controls/button/button";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Modal from "components/ui/modal/modal";
import { AppContext } from "components/app/RemExprertProvider";
import { applyFormat } from "components/ui/ui-helpers";
import Dialogs from "components/ui/dialogs/dialogs";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import { RemExpertResultatSalarie } from "components/app/Api/ResultatRemExpertSalarieProvider";
import RGProvider, { RGContext } from "components/app/AuditComplet/Retraite/Parametrage/ReleveRG/RGProvider";
import AjoutPeriodePageModal from "pages/audit complet/retraite/ajout periode modal";
import AjoutRISPageModal from "pages/audit complet/retraite/ajout RIS modal";
import { CalculCumulEmploiRetraite } from "components/app/Api/Retraite/ApiRetraite";
import { IconButton, Tooltip } from "@mui/material";
import AjoutPeriodeCumulEmploiPageModal from "./cumulEmploiRetraite/ajout periode cumul emploi modal";
import ParamRetraitePageModalCumulEmploi from "./cumulEmploiRetraite/parametrage retraite cumul emploi modal";
import _ from "lodash";
import AlertLURAModalCumulEmploi from "./cumulEmploiRetraite/alert LURA";
import { CorrespondanceActivite } from "components/app/RemExpertIntialState";
import DetailPension from "pages/audit complet/résultat/detail/retraite/DetailPension";
import { AuditCERWord } from "components/app/Api/Rapport/ApiRapport";
import Pager from "components/ui/controls/pager/pager";
import InfoMessage from "components/ui/controls/info-message";

// Styles CSS pour l'animation
const styles = `
  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-4px);
    }
    60% {
      transform: translateY(-2px);
    }
  }
  
  /* Style de scrollbar personnalisé pour Webkit */
  .custom-scrollbar::-webkit-scrollbar {
    width: 6px;
  }
  
  .custom-scrollbar::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
  }
  
  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
  }
  
  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`;

// Injection des styles
if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}


// Period Card Component
const PeriodCard = ({ period, index, onEdit, onDelete, canDelete, correspondanceActivite, longText }) => {
  const getActivityIcon = (nature) => {
    if (nature?.includes("Salarie") || nature?.includes("Fonction")) {
      return <FaBriefcase style={{ fontSize: 14, color: "#0d47a1" }} />;
    }
    return <FaUser style={{ fontSize: 14, color: "#0d47a1" }} />;
  };

  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: "12px",
        padding: "12px 16px",
        marginBottom: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        border: "1px solid #f0f0f0",
        transition: "all 0.2s ease",
        cursor: "pointer",
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.12)";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
          <div
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              backgroundColor: "#e3f2fd",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "12px",
            }}
          >
            {getActivityIcon(period.Nature)}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
              <h4
                style={{
                  margin: 0,
                  fontSize: "12px",
                  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                  fontWeight: 600,
                  color: "#333",
                  marginRight: "12px",
                }}
              >
                {correspondanceActivite[period.Nature] || "Activité non définie"}
              </h4>
            </div>
            {period.CumulEmploi === true ? (
              <div style={{ display: "flex", alignItems: "center", gap: "16px", marginTop: "8px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                  <FaCalendarAlt style={{ fontSize: 10, color: "#666" }} />
                  <span
                    style={{
                      fontSize: "10px",
                      fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                      color: "#666",
                    }}
                  >
                    {applyFormat(period.Debut, "date", "")}
                  </span>
                </div>
                <span style={{ color: "#ccc", fontSize: "10px" }}>→</span>
                <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                  <FaCalendarAlt style={{ fontSize: 10, color: "#666" }} />
                  <span
                    style={{
                      fontSize: "10px",
                      fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                      color: "#666",
                    }}
                  >
                    {applyFormat(period.Fin, "date", "")}
                  </span>
                </div>
              </div>
            ) : (
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "8px" }}>
                <FaExclamationTriangle style={{ fontSize: 12, color: "#f57c00" }} />
                <span
                  style={{
                    fontSize: "10px",
                    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                    color: "#666",
                  }}
                >
                  Dates non disponibles pour le cumul emploi retraite
                </span>
              </div>
            )}
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {period.CumulEmploi === true && (
            <>
              <Button
                onClick={onEdit}
                icon
                style={{
                  display: "inline-flex",
                  padding: "8px",
                  backgroundColor: "#f0fff4",
                  border: "none",
                  borderRadius: "6px",
                }}
              >
                <FaEdit style={{ color: "#22c55e" }} />
              </Button>
              {canDelete && (
                <Button
                  onClick={onDelete}
                  icon
                  style={{
                    display: "inline-flex",
                    padding: "8px",
                    backgroundColor: "#fff5f5",
                    border: "none",
                    borderRadius: "6px",
                  }}
                >
                  <FaTrashAlt style={{ color: "#f56565" }} />
                </Button>
              )}
            </>
          )}
          {period.CumulEmploi === false && (
            <Tooltip title={<div style={{ whiteSpace: "pre-line", textAlign: "justify" }}>{longText}</div>} placement="left" zIndex="9999">
              <IconButton style={{ padding: "8px" }}>
                <FaExclamationTriangle color="#f57c00" style={{ width: "15px", height: "15px" }} />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>
    </div>
  );
};

// Modern Cumul Emploi Retraite Chart Component
const ModernCumulChart = ({ context, clientConjoint, handleRAZ, handlePrint }) => {
    const ResultatTNS = useContext(RemExpertResultatTNS);
  return (
    <div
      style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        height: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "20px",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: "14px",
            fontWeight: 600,
            color: "#374151",
          }}
        >
          Taux de remplacement
        </h3>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <svg width="160" height="160" viewBox="0 0 160 160">
          {/* Background circle */}
          <circle cx="80" cy="80" r="70" fill="none" stroke="#F3F4F6" strokeWidth="8" />
          {/* Progress circle - pour le cumul emploi retraite */}
          <circle
            cx="80"
            cy="80"
            r="70"
            fill="none"
            stroke="#4F46E5"
            strokeWidth="8"
            strokeDasharray="440"
            strokeDashoffset={(() => {
              const tauxRemplacement = ((ResultatTNS?.state["Retraite" + clientConjoint]?.TotalRetraiteNetteChoixDepartRetraite || 0) + (context.state["CumulEmploiResult" + clientConjoint]?.TotalPensionNette || 0)) / (context.state["CarriereSalaireReference" + clientConjoint] || 1) * 100;
              return 440 - (440 * tauxRemplacement) / 100;
            })()}
            transform="rotate(-90 80 80)"
            strokeLinecap="round"
          />
          <text x="80" y="88" textAnchor="middle" fontSize="20px" fill="#374151" fontWeight="600">
            {Math.round(((ResultatTNS?.state["Retraite" + clientConjoint]?.TotalRetraiteNetteChoixDepartRetraite || 0) + (context.state["CumulEmploiResult" + clientConjoint]?.TotalPensionNette || 0)) / (context.state["CarriereSalaireReference" + clientConjoint] || 1) * 100)}%
          </text>
        </svg>
      </div>
      {/* Goal cards grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "12px",
          marginBottom: "20px",
          flex: 1,
        }}
      >
        <div
          style={{
            backgroundColor: "#E8F5E9",
            borderRadius: "12px",
            padding: "12px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "80px",
          }}
        >
          <div
            style={{
              width: "28px",
              height: "28px",
              backgroundColor: "#C8E6C9",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 6px",
            }}
          >
            <FaChartLine style={{ fontSize: "12px", color: "#2E7D32" }} />
          </div>
          <div style={{ fontSize: "11px", fontWeight: 600, color: "#1B5E20", marginBottom: "3px" }}>Trimestres supplémentaires</div>
          <div style={{ fontSize: "12px", fontWeight: 600, color: "#388E3C" }}>
            {context.state["CumulEmploiResult" + clientConjoint]?.TotalTrimestre }
          </div>
        </div>
        <div
          style={{
            backgroundColor: "#eff6ff",
            borderRadius: "12px",
            padding: "12px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "80px",
          }}
        >
          <div
            style={{
              width: "28px",
              height: "28px",
              backgroundColor: "#dbeafe",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 6px",
            }}
          >
            <FaUsers style={{ fontSize: "12px", color: "#2563eb" }} />
          </div>
          <div style={{ fontSize: "11px", fontWeight: 600, color: "#1d4ed8", marginBottom: "3px" }}>Âge Départ</div>
          <div style={{ fontSize: "12px", fontWeight: 600, color: "#3b82f6" }}>{context.state["CumulEmploiAgeDepartRetraite" + clientConjoint] || "N/A"}</div>
        </div>
        <div
          style={{
            backgroundColor: "#faf5ff",
            borderRadius: "12px",
            padding: "12px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "80px",
          }}
        >
          <div
            style={{
              width: "28px",
              height: "28px",
              backgroundColor: "#e9d5ff",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 6px",
            }}
          >
            <FaCheck style={{ fontSize: "12px", color: "#9333ea" }} />
          </div>
          <div style={{ fontSize: "11px", fontWeight: 600, color: "#7c3aed", marginBottom: "3px" }}>Date de départ</div>
          <div style={{ fontSize: "12px", fontWeight: 600, color: "#a855f7" }}>{context.state["CumulEmploiDateDepartRetraiteAffichage" + clientConjoint] || "N/A"}</div>
        </div>
        <div
          style={{
            backgroundColor: "#fef2f2",
            borderRadius: "12px",
            padding: "12px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "80px",
          }}
        >
          <div
            style={{
              width: "28px",
              height: "28px",
              backgroundColor: "#fecaca",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 6px",
            }}
          >
            <FaDollarSign style={{ fontSize: "12px", color: "#dc2626" }} />
          </div>
          <div style={{ fontSize: "11px", fontWeight: 600, color: "#b91c1c", marginBottom: "3px" }}>Retraite nette mensuelle</div>
          <div style={{ fontSize: "14px", fontWeight: 700, color: "#ef4444" }}>
            {applyFormat(ResultatTNS?.state["Retraite" + clientConjoint].TotalRetraiteNetteChoixDepartRetraite / 12+context.state["CumulEmploiResult" + clientConjoint]?.TotalPensionNette/12 , "uint", { thousands: " ", decimal: ",", unit: " €" })}
          </div>
        </div>
      </div>
      {/* Boutons d'action */}
      <div style={{ display: "flex", flexDirection: "column", gap: "12px", width: "100%" }}>
        {/* Bouton Impression */}
        <div style={{ width: "100%" }}>
          <ActionButton
            onClick={() => {
              AuditCERWord(context.state, clientConjoint, ResultatTNS.state, context.state["CumulEmploiResult" + clientConjoint]);
            }}
            icon={FaPrint}
            title="Imprimer l'étude"
            subtitle="Générer le rapport"
            colors={{
              primary: "#059669",
              secondary: "#047857",
              shadow: "rgba(5, 150, 105, 0.4)",
              shadowHover: "rgba(5, 150, 105, 0.6)",
            }}
            decorativeIcon={{ type: "document" }}
            style={{ width: "100%", minWidth: "100%" }}
          />
        </div>
        {/* Bouton remise à zéro */}
        <div style={{ width: "100%" }}>
          <ActionButton
            onClick={() => {
              handleRAZ();
            }}
            icon={FaUndo}
            title="Réinitialiser"
            subtitle="Remettre à zéro"
            colors={{
              primary: "#3b82f6",
              secondary: "#1d4ed8",
              shadow: "rgba(59, 130, 246, 0.3)",
              shadowHover: "rgba(59, 130, 246, 0.6)",
            }}
            decorativeIcon={{ type: "reset" }}
            style={{ width: "100%", minWidth: "100%" }}
          />
        </div>
      </div>
    </div>
  );
};

const CumulEmploiRetraitePage = (props) => {
  const context = useContext(AppContext);
  const [clientConjoint, setClientConjoint] = useState("");
  const [modalPeriodeRetr, setmodalPeriodeRetr] = useState(false);
  const [modalRISRetr, setmodalRISRetr] = useState(false);
  const [modalAgree, setmodalAgree] = useState(true);
  const [modalAlertLURA, setmodalAlertLURA] = useState(false);
  const [modalParamRetrOpen, setmodalParamRetrOpen] = useState(false);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const ResultatSalarie = useContext(RemExpertResultatSalarie);
  const Periode = context.state["PeriodeActuelle"][0];
  const PeriodeConjoint = context.state["PeriodeActuelleConjoint"][0];

  useEffect(() => {
    context.handleCalculCumulEmploiRetraite(props.ClientConjoint, context.state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (props.ClientConjoint === "") {
      setClientConjoint("");
    } else {
      setClientConjoint("Conjoint");
    }
  }, [props.ClientConjoint]);
  useEffect(() => {
    setmodalAlertLURA(context.state.CumulEmploiAlertLURA);
  }, [context.state.CumulEmploiAlertLURA]);

  const handleRAZ = () => {
    context.handleValueChange("CumulEmploiChoixDepartRetraite" + clientConjoint, "");
    context.handleValueChange("CumulEmploiCarriere" + clientConjoint, []);

    let data = _.cloneDeep(context.state);
    data.CumulEmploiAlertLURA = false;
    data.CumulEmploisIdsLURA = [];
    data["CumulEmploiChoixDepartRetraite" + clientConjoint] = "";
    data["CumulEmploiCarriere" + clientConjoint] = [];
    context.handleCalculCumulEmploiRetraite(props.ClientConjoint, data);
  };

  //   const longText = `
  //   Nous vous rappelons que dans le cadre de la simulation, les charges sociales sont considérées comme provisionnées à la clôture de l’exercice et donc déductibles fiscalement.
  //   Pour qu’elles le soient en pratique, il est indispensable que la distribution de dividendes intervienne avant la clôture de l’exercice en question.

  //   A titre d’exemple, lorsqu’un arbitrage est réalisé en 2023, il est indispensable que la distribution de dividendes intervienne avant la clôture de l’exercice 2023. Le
  //   cas échéant, les charges sociales générées par la distribution de dividendes ne pourront pas être déduites du résultat de l’exercice 2023.
  // `;
  const longText = `
le logiciel ne traite pas à ce jour le cumul emploi retraite sur l'activité saisie.

`;

  return (
    <>
      <Column fill>
        <Row>
          <Column fill>
            <CardBox bpad>
              <Column fill>
                {/* <Row center>
                  <Column></Column>
                  <Column style={{ paddingLeft: 0 }}>
                    <Button
                      onClick={() => {
                        props.accesSimulation();
                      }}
                    >
                      <span>Retour aux simulations</span>
                      <FaPlusCircle />
                    </Button>
                  </Column>
                </Row> */}
                <Row>
                  <InfoMessage
                    text={
                      <>
                        Dans le cadre du simulateur de CER, vous avez la possibilité de modifier une période d'activité existante ou de créer une période correspondant à une nouvelle
                        activité. La date de début de la période existante ou créée est au minimum égale à la date de départ en retraite initiale. Par défaut, les périodes existantes sont
                        projetées sur 5 ans. Les périodes pour lesquelles les dates de début et de fin sont remplacées par des "-" ne peuvent pas être projetées dans le cadre du simulateur
                        de CER.
                        <br />
                        <br />
                        <FaExclamationTriangle color="red" style={{ width: "15px", height: "15px" }} /> En cas de chargement d'un dossier sauvegardé, la modification de la carrière initiale
                        ne modifie pas la simulation. Pour la remettre à défaut, vous pouvez cliquer sur le bouton "Réinitialiser" en bas à droite de l'écran.
                      </>
                    }
                  />
                </Row>
              </Column>
            </CardBox>
          </Column>
        </Row>

        <Row>
          <Column fill>
            <div className="page-title-container">
              <div className="page-title-content">
                <div className="page-title-icon">
                  <FaGraduationCap />
                </div>
                <div className="page-title-text">
                  <h1>Cumul emploi retraite {context.state["Prenom" + clientConjoint]}</h1>
                  <p className="page-title-subtitle">Étudiez l'opportunité d'un cumul emploi retraite pour votre client</p>
                </div>
              </div>
              <div className="page-title-badge">
                <FaCalculator />
                <span>Simulation</span>
              </div>
            </div>
            <Column fill>
              {/* Boutons d'action modernisés */}
              <div style={{ marginBottom: "20px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                  <ActionButton
                    onClick={() => {
                      context.handleResetPeriodeRetraite(clientConjoint, "CumulEmploi");
                      setmodalPeriodeRetr(true);
                    }}
                    icon={FaPlusCircle}
                    title="Ajouter une période"
                    subtitle={`Pour ${context.state["Prenom" + clientConjoint]}`}
                    colors={{
                      primary: "#11998e",
                      secondary: "#0d7377",
                      shadow: "rgba(17, 153, 142, 0.4)",
                      shadowHover: "rgba(17, 153, 142, 0.6)",
                    }}
                    decorativeIcon={{ type: "calendar" }}
                    style={{ width: "215px" }}
                  />
                  <ActionButton
                    onClick={() => {
                      setmodalParamRetrOpen(true);
                    }}
                    icon={FaCogs}
                    title="Paramètres retraite"
                    subtitle={`Pour ${context.state["Prenom" + clientConjoint]}`}
                    colors={{
                      primary: "#e57373",
                      secondary: "#c62828",
                      shadow: "rgba(229, 115, 115, 0.4)",
                      shadowHover: "rgba(229, 115, 115, 0.6)",
                    }}
                    decorativeIcon={{ type: "settings" }}
                    style={{ width: "215px" }}
                  />
                </div>
              </div>
              <div style={{ display: "flex", gap: 24, alignItems: "stretch", height: "620px" }}>
                {/* Colonne de gauche - Tableau des périodes (moins large) */}
                <div style={{ flex: 3.5, minWidth: 0, position: "relative", display: "flex" }}>
                  <div
                    style={{
                      backgroundColor: "white",
                      borderRadius: "16px",
                      padding: "24px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                      border: "1px solid #f0f0f0",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      flex: 1,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "20px",
                        paddingBottom: "16px",
                        borderBottom: "2px solid #f0f0f0",
                      }}
                    >
                      <div>
                        <h3
                          style={{
                            margin: 0,
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#333",
                            marginBottom: "4px",
                          }}
                        >
                          Périodes de cumul emploi retraite
                        </h3>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "12px",
                            color: "#666",
                          }}
                        >
                          Historique des activités en cumul emploi retraite
                        </p>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <span
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            backgroundColor: "#f8f9fa",
                            padding: "6px 12px",
                            borderRadius: "20px",
                          }}
                        >
                          {context.state["CumulEmploiCarriere" + clientConjoint]?.length || 0} période(s)
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        overflow: "auto",
                        flex: 1,
                        scrollbarWidth: "thin",
                        scrollbarColor: "#cbd5e1 #f1f5f9",
                        paddingRight: "12px",
                        marginRight: "4px",
                      }}
                      className="custom-scrollbar"
                    >
                      {context.state["CumulEmploiCarriere" + clientConjoint]?.map((Infos, Index) => (
                        <PeriodCard
                          key={Index}
                          period={Infos}
                          index={Index}
                          correspondanceActivite={CorrespondanceActivite}
                          longText={longText}
                          onEdit={() => {
                            context.handleModifyDeletePeriodeRetraite(Infos.id, "Modifier", "CumulEmploi", clientConjoint);
                            setmodalPeriodeRetr(true);
                          }}
                          onDelete={() => {
                            Dialogs.confirm("Vous êtes sur le point de supprimer la période.\nVoulez-vous continuer ?", "Suppression de la période", () => {
                              context.handleModifyDeletePeriodeRetraite(Infos.id, "Supprimer", "CumulEmploi", clientConjoint);
                            });
                          }}
                          canDelete={true}
                        />
                      ))}
                    </div>
                  </div>
                </div>
                
                {/* Colonne de droite - Dashboard (plus large) */}
                <div style={{ flex: 1, minWidth: 300, position: "relative", display: "flex" }}>
                  <div
                    style={{
                      backgroundColor: "white",
                      borderRadius: "16px",
                      padding: "24px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                      border: "1px solid #f0f0f0",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      flex: 1,
                    }}
                  >
                    <ModernCumulChart
                      context={context}
                      clientConjoint={clientConjoint}
                      handleRAZ={handleRAZ}
                      handlePrint={() => {
                        AuditCERWord(context.state, clientConjoint, ResultatTNS.state, context.state["CumulEmploiResult" + clientConjoint]);
                      }}
                    />
                  </div>
                </div>
              </div>
            </Column>
          </Column>
        </Row>
      </Column>
      {/* {context.state.CumulEmploiResult !== undefined && <DetailPension Outil={""} InfosPension={context.state["CumulEmploiResult"+clientConjoint]} />} */}
      <Modal
        width="80%"
        height="80%"
        title="Ajouter une période"
        icon={<FaGlobe />}
        visible={modalPeriodeRetr}
        onClose={() => {
          setmodalPeriodeRetr(false);
        }}
      >
        <AjoutPeriodeCumulEmploiPageModal
          Outil="CumulEmploi"
          ClientConjoint={clientConjoint}
          visible={modalPeriodeRetr}
          onClose={() => {
            setmodalPeriodeRetr(false);
          }}
        />
      </Modal>
      <Modal
        width="80%"
        height="80%"
        title="Paramétrage de la retraite"
        icon={<FaGlobe />}
        visible={modalParamRetrOpen}
        onClose={() => {
          setmodalParamRetrOpen(false);
        }}
      >
        <ParamRetraitePageModalCumulEmploi
          Outil=""
          ClientConjoint={clientConjoint}
          visible={modalParamRetrOpen}
          onClose={() => {
            setmodalParamRetrOpen(false);
          }}
        />
      </Modal>
      <Modal
        width="75%"
        height="55%"
        title="POINT D'ATTENTION SUR LA LURA"
        icon={<FaGlobe />}
        visible={modalAlertLURA}
        hideClose={true}
        onClose={() => {
          context.handleValueChange("CumulEmploiAlertLURA", false);
        }}
      >
        <AlertLURAModalCumulEmploi
          Outil=""
          ClientConjoint={clientConjoint}
          visible={modalAlertLURA}
          onClose={() => {
            context.handleValueChange("CumulEmploiAlertLURA", false);
          }}
        />
      </Modal>
      <Modal
        width="45%"
        height="33%"
        // title="POINT D'ATTENTION SUR LA LURA"
        // icon={<FaGlobe />}
        visible={modalAgree}
        hideClose={true}
        onClose={() => {
          setmodalAgree(false);
        }}
      >
        <Pager
          pages={[
            {
              content: (
                <>
                  <Column fill>
                    <CardBox>
                      <Column fill>
                        <Row>
                          <Column>
                            <InfoMessage
                              text={
                                <>
                                  Nous vous alertons sur le fait que le simulateur n'a vocation qu'à déterminer la nouvelle pension issue du CER. Il vous appartient donc de vérifier que les
                                  conditions du cumul intégral sont remplies.
                                </>
                              }
                            />
                          </Column>
                        </Row>
                      </Column>
                    </CardBox>
                  </Column>
                </>
              ),
            },
          ]}
          page={0}
          navButtons={{
            // cancel: {},
            validate: {
              onClick: (evt) => {
                setmodalAgree(false);
                // context.handleCalculCumulEmploiRetraite(props.ClientConjoint, data);
                // context.handleCalculCumulEmploiRetraite(props.ClientConjoint, context.state);
              },
            },
          }}
        />
      </Modal>
    </>
  );
};

export default CumulEmploiRetraitePage;
